module.exports = __webpack_public_path__ + "e709f94f3a145b103f3c8370d20eb674.svg";